import { Button, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";

function InterviewTooltipModal({
  tooltipModal,
  setTooltipModal,
  interviewMode,
}) {
  return (
    <Modal
      title={`${interviewMode} Mode`}
      open={tooltipModal}
      onCancel={() => {
        setTooltipModal(false);
      }}
      centered
      footer={null}
    >
      {interviewMode === "Manual" ? (
        <>
          <div className="mt-1">
            In Manual Mode, you need to manually press Start or Stop answering
            buttons to begin and end your answers. Take your time to respond at
            your own pace.
          </div>
          <div className="mt-2">
            <span className="font-bold">Important:</span> This is the
            recommended option if you are in an environment with background
            disturbances.
          </div>
          <div className="mt-2 mb-[.2rem]">
            Switch to <span className="font-bold">Hands-free Mode</span> if you
            want seamless automatic conversation without the need to press Start
            or Stop buttons.
          </div>
        </>
      ) : (
        <>
          <div className="mt-1">
            In Hands-free Mode, your answers will start when you start speaking
            and end automatically when a brief pause is detected without the
            need to press Start or Stop buttons.
          </div>
          <div className="mt-2">
            <span className="font-bold">Note:</span> Background noises and other
            disturbances can sometimes trigger your speech start or not detect
            the speech end resulting in unexpected or no responses from Maya.
          </div>
          <div className="mt-2 mb-[.2rem]">
            <span className="font-bold">Important:</span> Ensure you are in a
            quiet environment to avoid unintended interruptions. Switch to
            <span className="font-bold"> Manual Mode</span> if you are facing
            audio issues or Maya is not responding.
          </div>
        </>
      )}
    </Modal>
  );
}

export default InterviewTooltipModal;
